import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import useAuth from '../../auth/useAuth';
import { gamesQuery, scenarioLevelsQuery } from './api';
import Tutorial from './tutorial';
import TutorialScramble from './tutorial-scramble';

export default function NormalRouterTutorial() {
  const params = useParams();
  const levelNumber = Number(params.levelNumber);
  
  const { getCurrentNormalGameId } = useAuth();
  const gameId = getCurrentNormalGameId();

  const { data: games, isLoading: gamesLoading } = useQuery(gamesQuery());
  
  const game = games?.find(game => game.id === gameId);
  const scenarioId = game?.scenario;

  const { data: scenarioLevels, isLoading: levelsLoading } = useQuery({
    ...scenarioLevelsQuery({ scenarioId }),
    enabled: !!scenarioId,
  });

  if (gamesLoading || !scenarioId || levelsLoading) {
    return null; 
  }

  const currentLevel = scenarioLevels?.find(scenarioLevel => scenarioLevel.level === levelNumber);

  if (!currentLevel) {
    console.warn(`Level ${levelNumber} not found in scenarioLevels`);
    return <Tutorial key={levelNumber} />;
  }

  const isScrambleLevel = currentLevel?.name?.toLowerCase().includes('scramble');

  if (isScrambleLevel) {
    return <TutorialScramble key={levelNumber} levelNumber={levelNumber} />;
  }

  return <Tutorial key={levelNumber} />;
}